
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "TPE/PME : stratégies pour accroître votre visibilité sur Google",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Apprenez les techniques de référencement essentielles pour renforcer la visibilité de votre TPE/PME sur Google et attirer davantage de clients en ligne.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "TPE/PME : Comment être visible sur Google ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Pourquoi et comment assurer la visibilité de votre entreprise dans Google ? Cet article vous apporte des réponses !",
        },
      ],
    };
  },
};
